import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {DataState} from '../../store/data.state';
import {EmitterService} from "@ngxs-labs/emitter";

@Injectable({
  providedIn: 'root'
})
export class TransactionResolver implements Resolve<undefined> {

  constructor(private readonly emitter: EmitterService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<undefined> {
    this.emitter.action(DataState.getTransaction).emit();
    return of(undefined);
  }
}
